/**
 * Debug helper to check authentication state
 */

export const debugAuth = async () => {
  console.group('🔍 Auth Debug Info');
  
  // Check localStorage
  const authKeys = Object.keys(localStorage).filter(key => key.includes('auth'));
  console.log('📦 LocalStorage auth keys:', authKeys);
  
  authKeys.forEach(key => {
    const value = localStorage.getItem(key);
    if (value) {
      try {
        const parsed = JSON.parse(value);
        console.log(`   ${key}:`, {
          user_id: parsed.user?.id,
          email: parsed.user?.email || parsed.email,
          token_preview: parsed.access_token?.substring(0, 30) + '...',
        });
      } catch (e) {
        console.log(`   ${key}:`, value.substring(0, 50) + '...');
      }
    }
  });
  
  // Check impersonation state
  const impToken = localStorage.getItem('admin_impersonation_token');
  const impState = localStorage.getItem('admin_impersonation_state');
  
  console.log('🎭 Impersonation state:', impState ? JSON.parse(impState) : 'Not impersonating');
  console.log('🎭 Impersonation token:', impToken ? impToken.substring(0, 30) + '...' : 'None');
  
  // Check Supabase session
  const { supabase } = await import('../lib/supabase');
  if (supabase) {
    const { data: { session } } = await supabase.auth.getSession();
    console.log('🔐 Supabase active session:', {
      user_id: session?.user?.id,
      email: session?.user?.email,
      token_preview: session?.access_token?.substring(0, 30) + '...',
    });
  }
  
  console.groupEnd();
};

// Expose globally for easy debugging
if (typeof window !== 'undefined') {
  (window as any).debugAuth = debugAuth;
}

